import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import PubMedDisplayStringSup from "./PubMedDisplayStringSup";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // optional
// import { sanitize } from 'dompurify';
import DOMPurify from "dompurify";
const sanitize = DOMPurify.sanitize;

class PubMedAbstractsAnswerDisplayString extends Component {
    constructor(props) {
        super(props);
        this.state = {
            KeyPoints: props.KeyPoints ? props.KeyPoints : "",
            Summary: props.Summary ? props.Summary : "",
            TableIndex: props.TableIndex ? props.TableIndex : "",
            abstractsIndex: props.abstractsIndex ? props.abstractsIndex : "",
            title: props.title ? props.title : ""
        }
    }
    componentWillReceiveProps(nextProps) {

    }


    render() {
        let { KeyPoints, Summary, TableIndex, abstractsIndex, title } = this.state;
        return (<><span dangerouslySetInnerHTML={{ __html: sanitize(`${KeyPoints}`) }} />
            <>
                <Tippy content={<>
                    <div className="gen-ai-answering-result-source-margin">
                        {title}
                    </div>
                    <div className="gen-ai-answering-result-source-margin">
                        index: {TableIndex}
                    </div></>}>
                    <sup custom-document-KeyPoints={KeyPoints} custom-Summary={Summary} custom-index={TableIndex}
                        onClick={() => {
                            //  this.props.handleClickOnSourceNumber(this.props.singleSource, this.props.pageNumber); 
                        }}
                        className="gen-ai-answering-result-main-answer-sup">
                        {abstractsIndex}</sup>
                </Tippy>
            </>
            <br />

        </>
        )
    }
}
export default withRouter(PubMedAbstractsAnswerDisplayString);